import React from "react";

// mui components
import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";

// custom components
import Heading5 from "../../typography/heading-05";

// custom styles
import styles from "../index.module.scss";

const TableHeadDocumentTrackerConditions = (props) => {
	const {
		rowCount,
		selectedCount,
		onSelectAllClick,
		label = "Condition Name",
	} = props;
	const showMetaColumns = Boolean(props?.showMetaColumns);

	return (
		<TableHead>
			<TableRow>
				<TableCell padding="checkbox">
					<Checkbox
						className={styles.checkboxContainer}
						indeterminate={selectedCount > 0 && selectedCount < rowCount}
						checked={rowCount > 0 && selectedCount === rowCount}
						onChange={onSelectAllClick}
						inputProps={{
							"aria-label": "select all conditions",
						}}
					/>
				</TableCell>
				<TableCell>
					<Heading5 text={label} extraClass={styles.thText} />
				</TableCell>
				<TableCell>
					<Heading5 text="Type" extraClass={styles.thText} />
				</TableCell>
				{showMetaColumns ? (
					<>
						<TableCell>
							<Heading5 text="Category" extraClass={styles.thText} />
						</TableCell>
						<TableCell>
							<Heading5 text="Prior" extraClass={styles.thText} />
						</TableCell>
					</>
				) : null}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadDocumentTrackerConditions;
